import { runtime } from './runtime.js';
export default {
    rpc: {},
    runtime,
    types: {
        NftCollectionId: 'u32',
        NftItemId: 'u32'
    }
};
